export const initialValuesContactWizard =
{
  projectId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  accountId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  primaryContactVMs: {
    contactId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    contactNo: "",
    organizationId: 0,
    firstName: "",
    lastName: "",
    email: "",
    isDeleted: true,
    isPrimaryContact: true,
    accountId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    lst_Account: {
      id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      value: ""
    },
    imageUrl: "",
    note: "",
    updatedBy: "",
    createdDT: "2024-11-29T15:19:34.287Z",
    updatedDT: "2024-11-29T15:19:34.287Z",
    contactTypeID: 0,
    contactStatusId: 0,
    companyName: "",
    salutationId: 0,
    maritalStatusId: 0,
    genderTypeId: 0,
    homePhone: "",
    workPhone: "",
    cellPhone: "",
    fax: "",
    homeEmail: "",
    workEmail: "",
    preferredMethodId: 0,
    perferredTime: "",
    isSubNewsLetter: true,
    isActive: true,
    addressLine1: "",
    addressLine2: "",
    addressAs: "",
    countryId: 0,
    city: "",
    state: "",
    zipCode: "",
    inquiryMethodId: 0,
    leadSourceId: 0,
    sourceDescription: "",
    country: {
      id: 0,
      title: ""
    },
    contactType: {
      id:17,
      name: "Primary Contact"
    },
    contactStatus: {
      id: 0,
      name: ""
    },
    salutation: {
      id: 0,
      name: ""
    },
    maritalStatus: {
      id: 0,
      name: ""
    },
    genderType: {
      id: 0,
      name: ""
    },
    inquiryMethod: {
      id: 0,
      name: ""
    },
    leadSource: {
      id: 0,
      name: ""
    },
    preferredMethod: {
      id: 0,
      name: ""
    },
    propertyAddress: {
      id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      contactId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      addressLine1: "",
      addressLine2: "",
      zipCode: "",
      stateId: 0,
      stateName: "",
      cityId: 0,
      cityName: "",
      chooseCityId: 0,
      chooseCityName: "",
      addressTypeId: 0,
      addressTypeName: ""
    },
    mailingAddress: {
      id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      contactId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      addressLine1: "",
      addressLine2: "",
      zipCode: "",
      stateId: 0,
      stateName: "",
      cityId: 0,
      cityName: "",
      chooseCityId: 0,
      chooseCityName: "",
      addressTypeId: 0,
      addressTypeName: ""
    }
  },
  secondaryContactVMs: {
    contactId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    contactNo: "",
    organizationId: 0,
    firstName: "",
    lastName: "",
    email: "",
    isDeleted: true,
    isPrimaryContact: true,
    accountId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    lst_Account: {
      id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      value: ""
    },
    imageUrl: "",
    note: "",
    updatedBy: "",
    createdDT: "2024-11-29T15:19:34.287Z",
    updatedDT: "2024-11-29T15:19:34.287Z",
    contactTypeID: 0,
    contactStatusId: 0,
    companyName: "",
    salutationId: 0,
    maritalStatusId: 0,
    genderTypeId: 0,
    homePhone: "",
    workPhone: "",
    cellPhone: "",
    fax: "",
    homeEmail: "",
    workEmail: "",
    preferredMethodId: 0,
    perferredTime: "",
    isSubNewsLetter: true,
    isActive: true,
    addressLine1: "",
    addressLine2: "",
    addressAs: "",
    countryId: 0,
    city: "",
    state: "",
    zipCode: "",
    inquiryMethodId: 0,
    leadSourceId: 0,
    sourceDescription: "",
    country: {
      id: 0,
      title: ""
    },
    contactType: {
      id: 0,
      name: ""
    },
    contactStatus: {
      id: 0,
      name: ""
    },
    salutation: {
      id: 0,
      name: ""
    },
    maritalStatus: {
      id: 0,
      name: ""
    },
    genderType: {
      id: 0,
      name: ""
    },
    inquiryMethod: {
      id: 0,
      name: ""
    },
    leadSource: {
      id: 0,
      name: ""
    },
    preferredMethod: {
      id: 0,
      name: ""
    },
    propertyAddress: {
      id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      contactId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      addressLine1: "",
      addressLine2: "",
      zipCode: "",
      stateId: 0,
      stateName: "",
      cityId: 0,
      cityName: "",
      chooseCityId: 0,
      chooseCityName: "",
      addressTypeId: 0,
      addressTypeName: ""
    },
    mailingAddress: {
      id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      contactId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      addressLine1: "",
      addressLine2: "",
      zipCode: "",
      stateId: 0,
      stateName: "",
      cityId: 0,
      cityName: "",
      chooseCityId: 0,
      chooseCityName: "",
      addressTypeId: 0,
      addressTypeName: ""
    }
  },
}